//MODIFICAR
// export const DOMAIN = 'http://localhost:8080'
export const DOMAIN = 'https://tinted-cheddar-soil.glitch.me'